module.exports = __webpack_public_path__ + "static/media/man.ea6b2b9a3f50fb6b41dd62e918844585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/man.jpg
// module id = 1877
// module chunks = 1